/* istanbul ignore file */
import React from 'react';
import { SolidButtonLink } from '@noths/polaris-client-ribbons-design-system';
import { getPathnameFromUrl } from '@noths/polaris-client-utils';
import type { GetServerSideProps } from 'next';

import { Seo } from 'src/components/atoms/Seo/Seo';
import { SKIP_CONTENT_TARGET_ID } from 'src/constants/elementIds';
import { getFeatureFlagsWithMatchers } from 'src/featureFlags/getFeatureFlagsWithMatchers';
import { fetchGlobalContent } from 'src/services/contentstack';
import * as styles from 'src/styles/giftCards.styles';

const title = 'Gift Cards';
const copy =
  'Not sure if they prefer brownies or macarons? White or red? Fresh flowers or dried? Give them what they really, really want with a Not On The High Street gift card.';

const GiftCards = () => (
  <>
    <Seo description={copy} title={title} />
    <div css={styles.container} id={SKIP_CONTENT_TARGET_ID}>
      <h1>{title}</h1>
      <p>{copy}</p>
      <div css={styles.linksWrapper}>
        <SolidButtonLink href="https://giftcards.notonthehighstreet.com/digital">
          Email a Gift Card
        </SolidButtonLink>
        <SolidButtonLink href="https://giftcards.notonthehighstreet.com/balance-check">
          Check Balance
        </SolidButtonLink>
      </div>
      <div css={styles.imageWrapper}>
        <img
          alt=""
          src="https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/bltba6f962bf007f7d7/68221f949b9d84d9d1dad861/gift-card-image.png"
        ></img>
      </div>
    </div>
  </>
);

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const featureFlags = (req && getFeatureFlagsWithMatchers(req)) || {};
  const pathname = getPathnameFromUrl(req.url ?? '');
  const [navData, topBannerData] = await fetchGlobalContent({ featureFlags, urlPath: pathname });

  return {
    props: {
      navData,
      topBannerData,
    },
  };
};

export default GiftCards;
